var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-portlet"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticStyle:{"height":"200px"},attrs:{"id":_vm.chart_id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }